import React from "react";
import { EVENTS } from "consts";
//
import WomensDay from "containers/templatesManager/eventsTemplates/WomensDay";
import Valentines from "containers/templatesManager/eventsTemplates/Valentines";
import Easter from "containers/templatesManager/eventsTemplates/Easter";

export default function TemplatesFactory({ template }) {
    switch (template?.name?.toLowerCase()) {
        case EVENTS.WOMENS_DAY:
            return <WomensDay />;
        case EVENTS.VALENTINES:
            return <Valentines />;
        case EVENTS.EASTER:
            return <Easter />;
        default:
            return <></>;
    }
}
